import React from "react";
import styled from "styled-components";

const Navigation = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d8d1cc;
  border-radius: 40px 40px 0px 0px;
  padding: 8px 0px;

  @media (min-width: 600px) {
    bottom: 0%;
    left: 50%;
    width: auto;
    transform: translate(-50%, -25%);
    border-radius: 100px;
    padding: 8px 16px;
  }
`;

//extracting selected/setSelected from props (AKA destructuring)
const NavComponent = ({ selected, setSelected }) => (
  <Navigation>
    <button
      className={selected === "all" ? "active" : ""}
      onClick={() => setSelected("all")}
    >
      All
    </button>
    <button
      className={selected === "a11y" ? "active" : ""}
      onClick={() => setSelected("a11y")}
    >
      A11Y
    </button>
    <button
      className={selected === "design" ? "active" : ""}
      onClick={() => setSelected("design")}
    >
      Design
    </button>
    <button
      className={selected === "product" ? "active" : ""}
      onClick={() => setSelected("product")}
    >
      Product
    </button>
    <button
      className={selected === "misc" ? "active" : ""}
      onClick={() => setSelected("misc")}
    >
      Misc.
    </button>
  </Navigation>
);

export default NavComponent;
